import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import AuthContext from "../../auth/context";
import { formatDateTime, formatTime } from "../../helpers/helpers";
import serverHost from "../../services/serverHost";
import { Box, Fab, ListItemText, Tooltip } from "@mui/material";
import MessageBlock from "./components/MessageBlock";
import { Grid } from "@mui/material";
import { useHistory } from "react-router-dom";
import Mp3Recorder from "./components/Mp3Recorder";
import { Stack } from "@mui/material";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

let acompanhamentoAberto = false;
let mensagemTexto = "";

export default function Acompanhamento(props) {
  const history = props.history;

  const usuario = useContext(AuthContext);
  const [unidadeId] = useState(props.match.params.unidadeId);
  const [profissionalId] = useState(props.match.params.profissionalId);
  const [dados, setDados] = useState({
    profissionalNome: "",
    escolaNome: "",
    unidadeNome: "",
    unidadeNumero: "",
  });
  const [velocidadeAudios, setVelocidadeAudios] = useState(
    localStorage.getItem("painel-admin-acompanhamento-velocidade-audios")
      ? Number(
          localStorage.getItem("painel-admin-acompanhamento-velocidade-audios")
        )
      : 1
  );
  const { notification } = useContext(AppContext);
  const [registros, setRegistros] = useState([]);
  const [registroSelecionado, setRegistroSelecionado] = useState({});
  const [audio, setAudio] = useState(undefined);
  const [audioURL, setAudioURL] = useState("");
  const [tempoAudio, setTempoAudio] = useState(0);

  useEffect(() => {
    carregarRegistros();
    // var element = document.getElementById("scroll");

    // element.scrollTo(0, element.scrollHeight);
  }, []);

  const carregarRegistros = () => {
    const registro = props.match.params;

    api
      .get("/acompanhamento/carregar", registro)
      .then((res) => {
        const registros = res;
        acompanhamentoAberto = false;

        if (registros.length === 0)
          return notification("warning", "Acompanhamento não iniciado.");

        registros.forEach((r) => {
          r.remetente = r.usuarioId > 0 ? r.usuarioNome : r.profissionalNome;

          r.audio = r.audio === "" ? "" : `${serverHost()}/${r.audio}`;
          r.envio = formatDateTime(r.envio, "D/M/Y h:m:s");
          r.emRespostaAAudio =
            r.emRespostaAAudio === "" || r.emRespostaAAudio === 0
              ? ""
              : `${serverHost()}/${r.emRespostaAAudio}`;
          acompanhamentoAberto = !r.dataHoraTermino;
        });

        setRegistros(registros);
        setDados(registros[0]);
        setAudio(undefined);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível carregar o acompanhamento. Verifique sua conexão e tente novamente."
        );
      });
  };

  const alterarVelocidade = (velocidade) => {
    localStorage.setItem(
      "painel-admin-acompanhamento-velocidade-audios",
      velocidade.velocidade.toString()
    );
    setVelocidadeAudios(velocidade.velocidade);
  };

  const fDados = {
    title: "Dados Do Acompanhamento",
    form: {
      escola: {
        label: "Escola",
        type: "text",
        space: 6,
        readOnly: true,
        value: dados.escolaNome,
      },
      profissional: {
        label: "Profissional",
        type: "text",
        space: 6,
        readOnly: true,
        value: dados.profissionalNome,
      },
      unidade: {
        label: "Unidade",
        type: "text",
        space: 6,
        readOnly: true,
        value: `${dados.unidadeNumero} - ${dados.unidadeNome}`,
      },
      situacao: {
        label: "Situação",
        type: "text",
        space: 4,
        readOnly: true,
        value: dados.dataHoraTermino ? "Finalizado" : "Em aberto",
      },
      velocidade: {
        label: "Velocidade dos áudios",
        type: "select",
        emptyItem: true,
        space: 2,
        options: [
          {
            value: 1,
            desc: "1x",
          },
          {
            value: 2,
            desc: "1.25x",
          },
          {
            value: 3,
            desc: "1.5x",
          },
          {
            value: 4,
            desc: "2x",
          },
        ],
        value: velocidadeAudios,
      },
    },

    submit: {
      label: "Buscar",
      action: alterarVelocidade,
      auto: true,
    },

    history,
    // close: true,
  };

  const novoRegistro = () => {
    const data = new FormData();

    data.append("unidadeId", unidadeId);
    data.append("profissionalId", profissionalId);
    data.append("texto", mensagemTexto);
    data.append("usuarioId", usuario.usuario.usuarioId);
    if (registroSelecionado.messageId) {
      data.append("emRespostaAId", registroSelecionado.messageId);
    }

    if (audio) {
      data.append("arquivo", audio);
      data.append("tempoAudio", tempoAudio);
    }

    api
      .put("/acompanhamento/inserir", data)
      .then((res) => {
        if (res) {
          notification("success", "Resposta enviada!");
          carregarRegistros();
          mensagemTexto = "";
          setRegistroSelecionado({});
        } else {
          notification("error", "Não foi possível enviar a resposta.");
        }
      })
      .catch((err) => {
        const { data } = err;

        switch (data[0]) {
          case 1:
            return notification("error", "Arquivo inválido");
          case 2:
            return notification("error", "Unidade inválida");
          case 3:
            return notification("error", "Profissional inválido");
          case 4:
            return notification("error", "Usuário inválido");
          default:
            return notification(
              "error",
              "Não foi possível enviar a resposta. Verifique sua conexão e tente novamente."
            );
        }
      });
  };

  const finalizarAbrirAcompanhamento = () => {
    const registro = {
      unidadeId: unidadeId,
      profissionalId: profissionalId,
    };

    if (acompanhamentoAberto) {
      api
        .post("acompanhamento/finalizar", registro)
        .then((res) => {
          if (res) {
            notification("success", "Acompanhamento finalizado.");
            carregarRegistros();
          } else {
            notification(
              "error",
              "Não foi possível finalizar o acompanhamento"
            );
          }
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 2:
              return notification("error", "Unidade inválida");
            case 3:
              return notification("error", "Profissional inválido");
            default:
              return notification(
                "error",
                "Não foi possível finalizar o acompanhamento. Verifique sua conexão e tente novamente."
              );
          }
        });
    } else {
      api
        .post("acompanhamento/reabrir", registro)
        .then((res) => {
          if (res) {
            notification("success", "Acompanhamento reaberto.");
            carregarRegistros();
          } else {
            notification("error", "Não foi possível reabrir o acompanhamento");
          }
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 2:
              return notification("error", "Unidade inválida");
            case 3:
              return notification("error", "Profissional inválido");
            default:
              return notification(
                "error",
                "Não foi possível reabrir o acompanhamento. Verifique sua conexão e tente novamente."
              );
          }
        });
    }
  };

  const gravarTexto = (form) => {
    mensagemTexto = form.mensagemTexto;
  };

  const fDadosEnviar = {
    // title: "Responder",
    form: {
      mensagemTexto: {
        label: "Mensagem",
        type: "textarea",
        space: 12,
        value: mensagemTexto,
      },

      cond: {
        label: "component",
        type: "component",
        value: (
          <Stack spacing={2} direction="row">
            <Button
              onClick={() => novoRegistro()}
              variant="contained"
              style={{ color: "white" }}
            >
              Enviar
            </Button>
            <Button
              onClick={() => history.goBack()}
              variant="contained"
              color="secondary"
            >
              Fechar
            </Button>
            <Button
              onClick={() => finalizarAbrirAcompanhamento()}
              variant="contained"
              color="info"
              style={{ color: "white" }}
            >
              {dados.dataHoraTermino ? "Reabrir" : "Finalizar"}
              {/* Finalizar */}
            </Button>
          </Stack>
        ),
      },
    },

    submit: {
      label: "Enviar",
      action: gravarTexto,
      auto: true,
    },
  };

  const selecionarResponder = (registro) => {
    setRegistroSelecionado(registro);
    document.getElementById("resposta").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="scroll">
      <Form formData={fDados} />
      <br />

      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          marginTop: "30px",
          marginBottom: 5,
        }}
      >
        <h4 style={{ marginLeft: 15, marginTop: 20 }}>Mensagens</h4>
        {registros.map((registro, key) => (
          <MessageBlock
            even={!registro.usuarioId}
            key={key}
            selectedUserPhotoUrl={""}
            data={{
              messageId: registro.id,
              message: registro.texto,
              audio: registro.audio,
              tempoAudio: registro.tempoAudio
                ? formatTime(registro.tempoAudio, "min ", "seg")
                : null,
              sent: registro.envio,
              author: registro.remetente,
              emRespostaAId: registro.emRespostaAId,
              emRespostaATexto: registro.emRespostaATexto,
              emRespostaAAudio: registro.emRespostaAAudio,
              profissionalNome: registro.profissionalNome,
            }}
            adminPhotoUrl={""}
            defaultAudioSpeed={velocidadeAudios}
            selecionarResponder={selecionarResponder}
          />
        ))}
      </Box>

      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          marginBottom: 5,
        }}
      >
        <Grid container alignItems="center">
          <Grid item xs={12}>
            <h4
              style={{
                margin: "10px 15px 0px 15px",
              }}
            >
              Responder
            </h4>
          </Grid>
          {registroSelecionado.messageId && (
            <Grid container style={{ margin: "10px 0px 0px 15px" }}>
              <p>Em resposta a:</p>
              <Grid
                style={{
                  background: "#E1EBFF",
                  // width: "60%",
                  borderRadius: 5,
                  textAlign: "center",
                  // margin: "0px 15px 0px 15px",
                  marginLeft: 15,
                }}
                container
                alignItems="center"
                xs={4}
              >
                <Grid container xs={10}>
                  <Grid item xs={12}>
                    <ListItemText style={{ marginLeft: 10 }} align="left">
                      <p style={{ fontWeight: "bolder" }}>
                        {registroSelecionado.author}
                      </p>
                    </ListItemText>
                  </Grid>
                  <Grid item xs={12}>
                    <>
                      {registroSelecionado.message !== "" && (
                        <ListItemText
                          style={{ marginLeft: 10 }}
                          align="left"
                          primary={registroSelecionado.message}
                        ></ListItemText>
                      )}
                      {registroSelecionado.audio !== "" && (
                        <>
                          <audio
                            id={`audio${registroSelecionado.messageId}`}
                            preload="none"
                            controls
                          >
                            <source src={registroSelecionado.audio} />
                          </audio>
                          {registroSelecionado.tempoAudio && (
                            <p
                              style={{
                                fontWeight: "bolder",
                                marginLeft: "15px",
                              }}
                              className="mb-0"
                            >
                              {registroSelecionado.tempoAudio}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  </Grid>
                </Grid>
                <Grid xs={2}>
                  <Tooltip title="Cancelar">
                    <Fab
                      color="primary"
                      aria-label="add"
                      size="small"
                      onClick={() => setRegistroSelecionado({})}
                    >
                      <CloseIcon />
                    </Fab>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={6} id="resposta">
            <Form formData={fDadosEnviar} />
          </Grid>
          <Grid item xs={5}>
            <Mp3Recorder
              recordedAudio={audio}
              recordedAudioURL={audioURL}
              getAudio={(audio, audioURL, tempoAudio) => {
                setAudio(audio);
                setAudioURL(audioURL);
                setTempoAudio(tempoAudio);
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* <Form>
        <Row>
          <Col sm={12} md={12} xl={6}>
            <FormGroup>
              <Label for="msg">Mensagem</Label>

              <Input
                ref={(input) => {
                  this.nameInput = input;
                }}
                type="textarea"
                name="msg"
                id="mensagem-texto"
                placeholder="Mensagem de texto"
                onChange={(e) =>
                  this.setState({ mensagemTexto: e.target.value })
                }
                value={this.state.mensagemTexto}
              />
            </FormGroup>
          </Col>
          <Col sm={12} md={12} xl={6}>
            <FormGroup>
              <Label for="audio">Áudio</Label>

              <Mp3Recorder
                recordedAudio={this.state.audio}
                recordedAudioURL={this.state.audioURL}
                getAudio={(audio, audioURL, tempoAudio) =>
                  this.setState({ audio, audioURL, tempoAudio })
                }
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <MatButton
            variant="contained"
            className="btn-warning mr-10 mb-10 text-white"
            onClick={() => this.novoRegistro()}
          >
            Enviar
          </MatButton>
          <MatButton
            variant="contained"
            className="btn-secondary mr-10 mb-10 text-white"
            onClick={() => this.props.history.goBack()}
          >
            Fechar
          </MatButton>

          {registros.length > 0 && (
            <MatButton
              variant="contained"
              color="primary"
              className="mr-10 mb-10 text-white"
              onClick={this.finalizarAbrirAcompanhamento}
            >
              {this.state.acompanhamentoAberto ? "Finalizar" : "Reabrir"}
            </MatButton>
          )}
        </Row>
      </Form> */}
    </div>
  );
}
